import axios from "axios";
import moment from "moment-timezone";
import { useState, useEffect } from "react";
import {
  DEFAULT_USER_IMG_URL,
  API_URL,
  MAIN_WEBSITE_URL,
} from "../constants/Globals";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faCheck } from "@fortawesome/free-solid-svg-icons";
import { getPercentage } from "../helpers/Number";

export default function DebatesBox({
  title = null,
  selectedGroup = "",
  selectedNetworks = [],
}) {
  const [debates, setDebates] = useState([]);
  const kTrans = (str) => str;

  useEffect(() => {
    axios
      .get(`${API_URL}/admin/debate/getPopularDebates`, {
        params: {
          categoryId: "all",
          pageNumber: 1,
          perPage: 10,
          groupId: selectedGroup,
          clientIds: selectedNetworks.join(","),
        },
      })
      .then(({ data }) => {
        setDebates(data.data);
      });
  }, [selectedGroup, selectedNetworks]);

  return (
    <div className="debates-box">
      {title ? <div className="debates-box-title">{title}</div> : null}
      <div className="debates-box-content">
        <div className="debates-box-list common-form">
          {debates.map((el, i) => {
            const hasSideImage =
              el.sides.findIndex((side) =>
                Boolean(side.sideBackgroundImageObject?.large.location)
              ) !== -1;
            return (
              <div className="topDebate relative" key={el.id}>
                <div className="debatePreviewSection1">
                  <div className="debatePreviewInner">
                    <div className="debatePreviewHeader inline-content middle">
                      <div className="author">
                        <a
                          target="_blank"
                          rel="noreferrer"
                          className="small-dp user-color-green"
                          href={`${MAIN_WEBSITE_URL}/${el.user.username}`}
                          tabIndex="0"
                        >
                          <img
                            style={{
                              borderColor: el.user.statusColor,
                            }}
                            data-src=""
                            src={
                              el.user.avatarObject
                                ? el.user.avatarObject.small.location
                                : DEFAULT_USER_IMG_URL
                            }
                            alt={el.user.name}
                            className="sidedLazyLoad img-circle avatar"
                            onError={(e) => {
                              e.target.src = DEFAULT_USER_IMG_URL;
                            }}
                          />
                          {el.user.roles.length > 0 && (
                            <>
                              {el.user.roles.find(
                                (role) => role.name === "VERIFIED"
                              ) ? (
                                <FontAwesomeIcon
                                  style={{
                                    color: el.user.checkmarkColor,
                                  }}
                                  icon={faCheckCircle}
                                  className="procheckmark"
                                />
                              ) : null}
                            </>
                          )}
                        </a>
                        <div className="copy-wrap">
                          <a
                            target="_blank"
                            rel="noreferrer"
                            className="authorname"
                            href={`${MAIN_WEBSITE_URL}/${el.user.username}`}
                            tabIndex="0"
                          >
                            <h6>{el.user.name}</h6>
                          </a>
                          <span className="authorhandle">
                            <span className="handler">
                              {kTrans("Posted")}{" "}
                              {moment(el.startedAt).format("MMM DD, YYYY")}
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="debatePreviewTitle mt-3">
                      {el.thesis !== "" ? (
                        <h5>
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href={`${MAIN_WEBSITE_URL}/${el.user.username}/${el.slug}`}
                          >
                            {el.thesis}
                          </a>
                        </h5>
                      ) : (
                        <>
                          <p></p>
                          <p></p>
                          <p></p>
                        </>
                      )}
                    </div>
                    {el.endedAt === null ? null : (
                      <span className="lightColorSpan mt-2 d-block">{`Poll ends in ${(Math.floor(moment(el.endedAt).diff(moment(), "minutes") / 1440) > 0 ? Math.floor(moment(el.endedAt).diff(moment(), "minutes") / 1440) + " day(s) " : Math.floor((moment(el.endedAt).diff(moment(), "minutes") % 1440) / 60) > 0 ? Math.floor((moment(el.endedAt).diff(moment(), "minutes") % 1440) / 60) + " hour(s) " : Math.floor((moment(el.endedAt).diff(moment(), "minutes") % 1440) % 60) > 0 ? Math.floor((moment(el.endedAt).diff(moment(), "minutes") % 1440) % 60) + " minute(s)" : "< 1 minute") ? (Math.floor(moment(el.endedAt).diff(moment(), "minutes") / 1440) > 0 ? Math.floor(moment(el.endedAt).diff(moment(), "minutes") / 1440) + " day(s) " : Math.floor((moment(el.endedAt).diff(moment(), "minutes") % 1440) / 60) > 0 ? Math.floor((moment(el.endedAt).diff(moment(), "minutes") % 1440) / 60) + " hour(s) " : Math.floor((moment(el.endedAt).diff(moment(), "minutes") % 1440) % 60) > 0 ? Math.floor((moment(el.endedAt).diff(moment(), "minutes") % 1440) % 60) + " minute(s)" : "< 1 minute") : ""}`}</span>
                    )}
                    {hasSideImage ? (
                      <div className="debatePreviewSides debatePreviewVotes">
                        {el.sides && el.sides.length
                          ? el.sides.map((elSides, i) => (
                              <div
                                className="side vote-container"
                                key={elSides.id}
                              >
                                <div className="message vote-image-container">
                                  <img
                                    alt="img"
                                    src={
                                      elSides.sideBackgroundImageObject?.large
                                        .location || "/images/image.png"
                                    }
                                  />
                                  <div className="vote-overlay">
                                    <div className="vote-text">
                                      {elSides.text}{" "}
                                    </div>
                                    <div className="vote-percentage">
                                      {getPercentage(elSides.votes, el.votes)}%
                                    </div>
                                  </div>
                                </div>
                                <div className="check-icon">
                                  <FontAwesomeIcon icon={faCheck} />
                                </div>
                              </div>
                            ))
                          : null}
                      </div>
                    ) : (
                      <div className="debatePreviewSides mt-2">
                        {el.sides && el.sides.length
                          ? el.sides.map((elSides, i) => (
                              <div className="side" key={elSides.id}>
                                <div className="message position-relative">
                                  <div
                                    className="poll-box"
                                    style={{
                                      borderLeftColor: elSides.sideColor,
                                    }}
                                  >
                                    <div
                                      className="full-side-bar"
                                      style={{
                                        backgroundColor: elSides.sideColor,
                                      }}
                                    ></div>

                                    <div
                                      style={{
                                        width:
                                          getPercentage(
                                            elSides.votes,
                                            el.votes
                                          ) + "%",
                                        backgroundColor: elSides.sideColor,
                                      }}
                                      className="overlay-box"
                                    ></div>
                                    <div className="poll-text">
                                      {elSides.text}{" "}
                                    </div>
                                    <div className="poll-percent">
                                      <span>
                                        {getPercentage(elSides.votes, el.votes)}
                                        %
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))
                          : null}
                      </div>
                    )}

                    <span className="lightColorSpan mt-2 d-block">
                      <span>
                        {el.votes} Vote{el.votes !== 1 ? "s" : ""} •{" "}
                        {el.comments} Comment
                        {el.comments !== 1 ? "s" : ""}{" "}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
